import { colors } from '@mui/material'

const white = '#FFFFFF'
const black = '#000000'

export default {
	black,
	white,
	primary: {
		light: '#fddebd',
		main: '#f79222',
		dark: '#c6751b',
		contrastText: '#fff',
	},
	secondary: {
		light: '#f9b3b9',
		main: '#ef404f',
		dark: '#601a20',
		contrastText: '#fff',
	},
	success: {
		contrastText: white,
		dark: colors.green[900],
		main: colors.green[600],
		light: colors.green[400],
	},
	info: {
		contrastText: white,
		dark: colors.blue[900],
		main: colors.blue[600],
		light: colors.blue[400],
	},
	warning: {
		contrastText: white,
		dark: colors.orange[900],
		main: colors.orange[600],
		light: colors.orange[400],
	},
	error: {
		contrastText: white,
		dark: colors.red[900],
		main: colors.red[600],
		light: colors.red[400],
	},
	text: {
		primary: '#000',
		secondary: "colors.grey[600]",
		link: '#f79222',
	},
	background: {
		default: '#F4F6F8',
		paper: white,
	},
	icon: '#f79222',
	divider: colors.grey[200],
	action: {
		disabledBackground: colors.grey[300],
		disabled: colors.grey[600],
	},
}
